var _a;
import { Document_Source_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Document_Source_Type.BillAdvocacy] = 'Bill Advocacy',
    _a[Document_Source_Type.Chat] = 'Chat',
    _a[Document_Source_Type.HipaaDocument] = 'HIPAA Document',
    _a[Document_Source_Type.InsuranceCard] = 'Insurance Card',
    _a[Document_Source_Type.Member] = 'Member-related documents',
    _a[Document_Source_Type.Organization] = 'Organization Document',
    _a);
export var DocumentSourceTypeEnum = {
    name: 'Document_Source_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
